export * from "./ProductSpecification";
